var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SearchableDropdown", {
    staticClass: "form-selector form__searchable-dropdown",
    attrs: { config: _vm.viewModel.dropdownConfig, clearable: _vm.clearable },
    model: {
      value: _vm.selectedTarget,
      callback: function($$v) {
        _vm.selectedTarget = $$v
      },
      expression: "selectedTarget"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }